import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { setDefaultHeader, apiCall } from '../../../utils/httpClient';
import ApiEndPoint from '../../../utils/apiEndPoints';
import { AuthContext } from '../../../Context/context';
import { LocalStorageKeys, LocalStorageService } from '../../../utils/LocalStorageService';
import { LoaderContext, UserDatailContext } from '../../../Context/userContext';
import styles from '../index.module.css';
import emailIcon from '../../../images/mail_svgrepo.png';
import passwordIcon from '../../../images/lock-password.png';
import Roles from '../../../utils/roles';

const LoginForm = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordShow, setPasswordShow] = useState(true);
  const [emailTouched, setEmailTouched] = useState(false);
  const [passTouched, setPassTouched] = useState(false);

  const navigate = useNavigate();
  const [, setIsLoading] = useContext(LoaderContext);
  const [, setUserDetails] = useContext(UserDatailContext);
  const { signOutFun, signInFun } = useContext(AuthContext);

  function logout() {
    navigate('/login-v2');
    signOutFun();
  }

  const lastLogin = async () => {
    const { data } = await apiCall('GET', ApiEndPoint.LAST_LOGIN);
    console.log("lastLogin", data);
    if (data?.success) {
      console.log("success", data.success);
    } else {
      setIsLoading(false);
      toast.error(data?.message, {
        position: "top-right"
      });
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setEmailTouched(true);
    setPassTouched(true);

    const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    const isValidEmail = email && email.match(validRegex);
    const isValidPass = password && password.length > 0;

    if (isValidEmail && isValidPass) {
      const params = {
        email: email,
        password: password,
        applicationId: process.env.REACT_APP_APP_ID,
      };
      setIsLoading(true);
      const { data } = await apiCall('POST', ApiEndPoint.SIGNIN, params);

      if (data?.success) {
        setUserDetails(data?.payLoad);

        const role = data?.payLoad?.role;
        const UserLevelValid =
          role === Roles.ANALYST ||
          role === Roles.GUEST_ANALYST ||
          role === Roles.DOCTOR_ANALYST ||
          role === Roles.PATHOLOGY_ANALYST ||
          role === Roles.LUNG_ANALYST;

        if (UserLevelValid) {
          await signInFun(data?.payLoad);
          await setDefaultHeader("Authorization", `Bearer ${data?.payLoad.authToken}`);
          lastLogin();
          if (role === Roles.DOCTOR_ANALYST) {
            navigate("/Dashboard");
          } else {
            navigate("/");
          }
        } else {
          toast.error("User Doesn't have Access", {
            position: "top-right",
          });
          logout();
        }
      } else {
        toast.error(data?.message, {
          position: "top-right",
        });
      }
      setIsLoading(false);
    } else {
      console.error('Validation failed');
    }
  };

  const handleForgotPassword = () => {
    alert(`Please contact ${process.env.REACT_APP_FORGOT_PASSWORD_CONTACT_MAIL} for password recovery or any related queries.`);
  }

  return (
    <div className={`col-12 col-md-4 ${styles['right-section']}`}>
      <div className={styles.login_panel}>
        <form className={styles['signIn-form']} onSubmit={handleLogin}>
          <div className={`${styles.company_logo} text-center`}>
            <img src='assets/GCD-3.svg' alt="Logo" />
          </div>
          <h6>Log in to your account</h6>

          <div className={styles['form-group']}>
            <span className={styles.icon}>
              <img src={emailIcon} alt="mail" />
            </span>
            <input
              type="email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onBlur={() => setEmailTouched(true)}
            />
            {emailTouched && (!email || !email.includes('@')) && (
              <div className={styles['error-message']}>Please enter a valid email address</div>
            )}
          </div>

          <div className={`${styles['form-group']} ${styles.password_section}`}>
            <span className={styles.icon}>
              <img src={passwordIcon} alt="lock" />
            </span>
            <input
              type={passwordShow ? "password" : "text"}
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onBlur={() => setPassTouched(true)}
            />
            <span onClick={() => setPasswordShow(!passwordShow)} className={styles.show_password}>
              <i className={passwordShow ? "zmdi zmdi-eye-off" : "zmdi zmdi-eye"}></i>
            </span>
            {passTouched && !password && (
              <div className={styles['error-message']}>Password field cannot be empty</div>
            )}
            <div className={`text-right ${styles['forgot-password-container']}`}>
              <a  className={styles.forgot_text} onClick={handleForgotPassword}>Forgot Password?</a>
            </div>
          </div>

          <button type="submit" className={styles['login-button']}>Log In</button>

          <div className={styles.login_footer}>
            <div className={styles.sign_up}>
              <span>Don't have an account? <a className={styles['sign_up-text']} onClick={() => navigate('/signup')}>Sign Up</a></span>
            </div>
            <div className={styles.terms_condi}>
              <span>Terms & Conditions</span>
              <span>Privacy</span>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;
